
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAnalogInleftBottom100 as ObiThreewayAnalogInleftBottom100Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-analog-inleft-bottom-100.js';
 
 
 

 
 export const ObiThreewayAnalogInleftBottom100 = createComponent({
   react: React,
   tagName: 'obi-threeway-analog-inleft-bottom-100',
   elementClass: ObiThreewayAnalogInleftBottom100Element,
   events: {
     
   }
  });
 
 